export enum LoadIndustryType {
  agriculturalProducts = 'agriculturalProducts',
  generalConstruction = 'generalConstruction',
  geothermalExploration = 'geothermalExploration',
  governmentOrMilitaryEquipment = 'governmentOrMilitaryEquipment',
  housesAndOtherStructures = 'housesAndOtherStructures',
  implementsOfHusbandry = 'implementsOfHusbandry',
  manufacturedHousing = 'manufacturedHousing',
  manufacturing = 'manufacturing',
  marineTransportation = 'marineTransportation',
  mining = 'mining',
  oilAndGasIndustry = 'oilAndGasIndustry',
  portableBuildings = 'portableBuildings',
  roadConstruction = 'roadConstruction',
  telecommunicationAndElectronicUtility = 'telecommunicationAndElectronicUtility',
  water = 'water',
  wasteWaterAndPipelineIndustry = 'wasteWaterAndPipelineIndustry',
  windEnergy = 'windEnergy',
  other = 'other',
}

export const LoadIndustryTypeValues = Object.values(LoadIndustryType);
